<template>
    <div class="uk-flex uk-flex-column uk-flex-middle">
        <div class="uk-width-1-2 uk-width-1-3@m uk-text-center">
            <h1> {{ status }} </h1>
            <p>{{ messageI18N }}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Error",
        props: {
            status: {
                type: Number,
                default: 404
            },
            message: {
                type: String,
                default: ""
            }
        },
        computed: {
            messageI18N() {
                return this.message ? this.message : this.$t("page_not_found")
            }
        }
    };
</script>